export default {
      id: "icon-bin-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "icons.svg#icon-bin",
      toString: function () {
        return this.url;
      }
    }